export const accountRoute = [
  // 就诊卡，地址、手机号、身高、体重等参数校验不通过，跳转到此页面
  {
    path: '/account/modify/pre',
    component: () => import('./modify/pre')
  },
  {
    path: '/account/prelogin',
    component: () => import('./prelogin')
  },
  {
    path: '/account/login',
    component: () => import('./login')
  },
  {
    path: '/account/notice',
    component: () => import('./notice')
  },
  {
    path: '/account/set-device',
    component: () => import('./set-device')
  },
  {
    path: '/account/reset/pwd',
    component: () => import('./reset/pwd.vue')
  },
  {
    path: '/account/reset/pwd2',
    component: () => import('./reset/pwd2.vue')
  },
  {
    path: '/account/login/bymobile',
    component: () => import('./login/bymobile.vue')
  },
  {
    path: '/account/login/bypwd',
    component: () => import('./login/bypwd.vue')
  },
  // 通用的修改手机号的界面
  {
    path: '/account/phone',
    component: () => import('./phone')
  }
]



// WEBPACK FOOTER //
// ./src/page/account/accountRoute.js